
import {
    GET_PARTNER_DISCLAIMER_REQUEST,
    GET_PARTNER_DISCLAIMER_SUCCESS,
    GET_PARTNER_DISCLAIMER_FAILURE,
} from '../../../../Constants/actionTypes';


const initialState = {
    disclaimer: null,
    loading: false,
    error: null,
  };
  
  const getPartnerDisclaimerReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_PARTNER_DISCLAIMER_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case GET_PARTNER_DISCLAIMER_SUCCESS:
        return {
          ...state,
          loading: false,
          disclaimer: action.payload,
        };
      case GET_PARTNER_DISCLAIMER_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default getPartnerDisclaimerReducer;